import { baseApi, defaultQueryFreshness } from "./baseApi";

export interface AuthResponseDto {
  token?: string;
  refreshToken?: string;
  user?: Record<string, unknown>;
  message?: string;
}

export const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<AuthResponseDto, { email: string; password: string }>({
      query: ({ email, password }) => ({ url: "/auth/login", method: "POST", data: { email, password }, usePublic: true }),
      invalidatesTags: ["Auth", "User"],
    }),
    register: builder.mutation<AuthResponseDto, Record<string, unknown>>({
      query: (payload) => ({ url: "/auth/register", method: "POST", data: payload, usePublic: true }),
      invalidatesTags: ["Auth", "User"],
    }),
    fetchMe: builder.query<Record<string, unknown>, void>({
      query: () => ({ url: "/auth/me", method: "GET" }),
      providesTags: ["Auth", "User"],
      ...defaultQueryFreshness,
    }),
    forgotPassword: builder.mutation<{ message?: string }, { email: string; redirectTo?: string }>({
      query: ({ email, redirectTo }) => ({
        url: "/auth/forgot-password",
        method: "POST",
        data: { email, redirectTo },
        usePublic: true,
      }),
    }),
    resetPassword: builder.mutation<{ message?: string }, { accessToken: string; password: string }>({
      query: ({ accessToken, password }) => ({
        url: "/auth/reset-password",
        method: "POST",
        data: { accessToken, password },
        usePublic: true,
      }),
    }),
    sendPhoneOtp: builder.mutation<{ message?: string }, { phone: string }>({
      query: ({ phone }) => ({ url: "/auth/phone/send-otp", method: "POST", data: { phone } }),
      invalidatesTags: ["Auth"],
    }),
    verifyPhoneOtp: builder.mutation<AuthResponseDto, { phone: string; code: string }>({
      query: ({ phone, code }) => ({ url: "/auth/phone/verify-otp", method: "POST", data: { phone, code } }),
      invalidatesTags: ["Auth", "User"],
    }),
  }),
});

export const {
  useLoginMutation,
  useRegisterMutation,
  useFetchMeQuery,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useSendPhoneOtpMutation,
  useVerifyPhoneOtpMutation,
} = authApi;
